import { _sharedActionsConstantsMainTree } from "./actions";
import { storeBooks } from "../../api/CacheHolder";
import { POSTFIX_BOOK_CODE_SG } from "@/shared/utils/content/content.constants";
import { getBookIdWithPrefix } from "@/shared/utils/content/content";

export const _sharedStateMainTree = {
  books: [],
  idsBooksFetchFailed: [],
  mainTree: [],
  langMap: {},
  bibles: [],
  sgBooksMap: {},
  bookLangMap: {},
  dictionaries: [],
  periodicals: [],
};

export const _sharedReducerMainTree = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsMainTree.SET_BOOKS: {
      return { ...state, books: action.data };
    }
    case _sharedActionsConstantsMainTree.ADD_ID_BOOK_FETCH_FAILED: {
      const idsBooksFetchFailedNew = [...state.idsBooksFetchFailed];

      idsBooksFetchFailedNew.push(action.data);

      return {
        ...state,
        idsBooksFetchFailed: idsBooksFetchFailedNew,
      };
    }
    case _sharedActionsConstantsMainTree.PUSH_BOOKS: {
      if (!action.data) {
        console.log(`%c⛔ Book is missing in action data`, "background: black; color: white;");
        return;
      }

      const existingBookIds = state.books.map(getBookIdWithPrefix);

      const payloadBooks = Array.isArray(action.data) ? action.data : [action.data];

      const newBooks = payloadBooks.filter((b) => !existingBookIds.includes(b.id));

      if (newBooks.length) {
        const booksNew = storeBooks(newBooks);

        if (booksNew) {
          return { ...state, books: booksNew };
        }
      }

      return state;
    }

    case _sharedActionsConstantsMainTree.FETCH_MAIN_TREE_SUCCESS: {
      const newState = { ...state, };
      const mainTree = action.data;

      if (mainTree?.length) {
        const langMap = {};
        mainTree.forEach((item) => {
          langMap[item.id] = item.label;
        });
        newState.langMap = langMap;
        newState.mainTree = mainTree;
      }

      return newState;
    }

    case _sharedActionsConstantsMainTree.FETCH_FOLDERS_TO_ROOT_SUCCESS: {
      const newState = { ...state, };


      const { mainTree, options } = action.data;

      if (mainTree?.length) {
        const langMap = {};
        mainTree.forEach((item) => {
          langMap[item.id] = item.label;
        });
        newState.langMap = langMap;
        newState.mainTree = mainTree;
      }


      const { bookLangMap, bibles, dictionaries, books } = options;

      if (bibles) {
        newState.bibles = bibles;
      }

      if (dictionaries) {
        newState.dictionaries = dictionaries;
      }

      if (books) {
        newState.books = storeBooks(books) || [];
      }

      if (bookLangMap) {
        newState.bookLangMap = {...newState.bookLangMap,  ...bookLangMap };
      }

      return newState;
    }
    case _sharedActionsConstantsMainTree.FETCH_BIBLES_SUCCESS:
      return { ...state, bibles: action.data };
    case _sharedActionsConstantsMainTree.FETCH_DICTIONARIES_SUCCESS:
      return { ...state, dictionaries: action.data };
    case _sharedActionsConstantsMainTree.FETCH_SG_BOOKS_SUCCESS:{
      const sgBooks = action.data;
      const sgBooksMap = {};
      sgBooks.forEach((item) => {
        const originalBookCode = item.code.replace(POSTFIX_BOOK_CODE_SG, "");
        sgBooksMap[originalBookCode] = item;
      });

      return { ...state, sgBooksMap: sgBooksMap };
    }
    default:
      return state;
  }
};
